/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import Lines from '../icons/menu';
import Backgrounds from '../icons/button';

import Label from '../partials/Label';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/menus/menu-item.scss';

const propTypes = {
    label: PropTypes.string,
    url: PropTypes.string,
    active: PropTypes.bool,
    external: PropTypes.bool,
    color: AppPropTypes.color,
    theme: PropTypes.string,
    size: PropTypes.string,
    index: PropTypes.number,
    icon: PropTypes.string,
    isChild: PropTypes.bool,
    margin: PropTypes.number,
    onClick: PropTypes.func,
    className: PropTypes.string,
};

const defaultProps = {
    label: null,
    url: null,
    active: false,
    external: false,
    color: null,
    theme: null,
    size: 'small',
    index: null,
    icon: null,
    isChild: false,
    margin: 0,
    onClick: null,
    className: null,
};

const MenuItem = ({
    label,
    url,
    active,
    external,
    color,
    theme,
    size,
    index,
    isChild,
    margin,
    icon,
    onClick,
    className,
}) => {
    if (!url) return null;

    const [random] = useState(Math.random());
    const [hover, setHover] = useState(false);
    const LineComponent = Lines[size];
    const LineComponentAlternate = Lines[`${size}-alt`];
    const Icon = icon !== null ? Lines[icon] : null; // Icon to the left
    const Background = Backgrounds.resizable; // Background shape

    const currentColor = theme !== 'dark' ? color : '#ffffff';
    const activeColor = theme !== 'dark' ? '#ffffff' : color;

    const hoverIn = useCallback(() => setHover(true));
    const hoverOut = useCallback(() => setHover(false));

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles[theme]]: theme !== null,
                    [styles.active]: active,
                    [styles.isChild]: isChild,
                },
            ])}
            key={`menu-item-${index}`}
            style={{ color: currentColor }}
        >
            {index === 0 && !isChild ? (
                <LineComponentAlternate className={styles.line} color={currentColor} />
            ) : null}
            {external ? (
                <a
                    href={url}
                    className={styles.link}
                    onMouseEnter={hoverIn}
                    onMouseLeave={hoverOut}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <span
                        style={{
                            marginLeft: margin,
                            color: !active && !hover ? currentColor : activeColor,
                        }}
                    >
                        {Icon !== null ? (
                            <Icon
                                className={styles.icon}
                                color={!hover ? currentColor : activeColor}
                            />
                        ) : null}
                        <Label>{label}</Label>
                    </span>
                    {active || hover ? (
                        <Background className={styles.background} color={currentColor} />
                    ) : null}
                </a>
            ) : (
                <div className={styles.linkContainer}>
                    <Link
                        className={styles.link}
                        to={url}
                        onClick={onClick}
                        onMouseEnter={hoverIn}
                        onMouseLeave={hoverOut}
                    >
                        <span
                            style={{
                                marginLeft: margin,
                                color: !active && !hover ? currentColor : activeColor,
                            }}
                        >
                            {Icon !== null ? (
                                <Icon
                                    className={styles.icon}
                                    color={!active && !hover ? currentColor : activeColor}
                                />
                            ) : null}
                            <Label>{label}</Label>
                        </span>
                        {active || hover ? (
                            <Background className={styles.background} color={currentColor} />
                        ) : null}
                    </Link>
                </div>
            )}
            {random > 0.5 ? (
                <LineComponentAlternate className={styles.line} color={currentColor} />
            ) : (
                <LineComponent className={styles.line} color={currentColor} />
            )}
        </div>
    );
};

MenuItem.propTypes = propTypes;
MenuItem.defaultProps = defaultProps;

export default MenuItem;
